import { render, staticRenderFns } from "./CopyrightAmendmentMessagesEscalated.vue?vue&type=template&id=7f6fc782&scoped=true&"
import script from "./CopyrightAmendmentMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6fc782",
  null
  
)

export default component.exports